import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import FeedbackIcon from "@mui/icons-material/Feedback";
import HelpCenterIcon from "@mui/icons-material/HelpCenter";
import LogoutIcon from "@mui/icons-material/Logout";
import SettingsIcon from "@mui/icons-material/Settings";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
} from "@mui/material";
import { useState } from "react";
import { trackAction } from "#next/utils/trackUserActions";
import { FeedbackModal } from "#next/components/modals/FeedbackModal";
import { HelpModal } from "#next/components/modals/HelpModal";
import { Link } from "#next/components/reusable/Link";
import { useGlobalAdmin } from "#next/components/base/Hooks";

export function AdminOptionsList({ onSelect }: { onSelect?: () => void }) {
  const [helpModalIsOpen, setHelpModalIsOpen] = useState(false);
  const [feedbackModalIsOpen, setFeedbackModalIsOpen] = useState(false);

  return (
    <List
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "end",
        flexGrow: 1,
      }}
    >
      {/*TODO: Arrange and style this section better */}
      <MenuItem
        sx={{ py: "4px" }}
        onClick={() => {
          trackAction("Feedback > Open");
          setFeedbackModalIsOpen(true);
          onSelect?.();
        }}
      >
        <ListItemIcon
          sx={{
            minWidth: "0px !important",
            mr: 1,
          }}
        >
          <FeedbackIcon />
        </ListItemIcon>
        <ListItemText>Feedback</ListItemText>
      </MenuItem>
      {feedbackModalIsOpen && (
        <FeedbackModal
          open={feedbackModalIsOpen}
          onClose={() => {
            setFeedbackModalIsOpen(false);
          }}
        />
      )}
      <MenuItem
        sx={{ py: "4px" }}
        onClick={() => {
          trackAction("Help > Open");
          setHelpModalIsOpen(true);
          onSelect?.();
        }}
      >
        <ListItemIcon
          sx={{
            minWidth: "0px !important",
            mr: 1,
          }}
        >
          <HelpCenterIcon />
        </ListItemIcon>
        <ListItemText>Help Center</ListItemText>
      </MenuItem>
      {helpModalIsOpen && (
        <HelpModal
          open={helpModalIsOpen}
          onClose={() => {
            setHelpModalIsOpen(false);
          }}
        />
      )}
      <ListItem sx={{ py: 0 }}>
        <ListItemIcon sx={{ minWidth: 0, mr: 1 }}>
          <SettingsIcon />
        </ListItemIcon>
        <ListItemText>
          <Link
            onClick={() => {
              trackAction("My Settings > Open");
              onSelect?.();
            }}
            href="/settings"
          >
            Settings
          </Link>
        </ListItemText>
      </ListItem>
      {useGlobalAdmin() && (
        <ListItem sx={{ py: 0 }}>
          <ListItemIcon sx={{ minWidth: 0, mr: 1 }}>
            <AdminPanelSettingsIcon />
          </ListItemIcon>
          <ListItemText>
            <Link
              onClick={() => {
                trackAction("Pyrra Admin > Open");
                onSelect?.();
              }}
              href="/admin"
            >
              Admin
            </Link>
          </ListItemText>
        </ListItem>
      )}
      <ListItem sx={{ py: 0 }}>
        <ListItemIcon sx={{ minWidth: 0, mr: 1 }}>
          <LogoutIcon />
        </ListItemIcon>
        <ListItemText>
          <Link onClick={() => onSelect?.()} href="/api/auth/logout">
            Logout
          </Link>
        </ListItemText>
      </ListItem>
    </List>
  );
}
